// @flow

import { createContext } from 'react';
import type { Context } from 'react';

import type { DecoratedProduct } from '@gandi/cart';

// $FlowFixMe[prop-missing] we are declaring an empty object instead of a real complex DecoratedProduct
export const ProductContext: Context<DecoratedProduct> = createContext({});
